import React from "react";
import PropTypes from "prop-types";
import Button from "shared/Button";
import AddToCartModal from "./AddToCartModal";
import { describePermission } from "./productPermission";
import styles from "./CreateOrderProductItem.module.css";

/**
 * Right-hand action control for a product row in the Order Management → Create
 * Order catalog: an Add To Cart button that opens the variation / size /
 * quantity modal (preceded by a permission override prompt when the product is
 * restricted to a higher tier than the selected IBO).
 */
export function CartItemActions({ product, onAddToCart, iboPinCode, iboMembershipCode }) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const permissionMessage = React.useMemo(
    () => describePermission(product, iboPinCode, iboMembershipCode),
    [product, iboPinCode, iboMembershipCode]
  );

  const handleConfirm = React.useCallback(
    (selection, quantity) => {
      onAddToCart(product, quantity, selection);
      setIsModalOpen(false);
    },
    [onAddToCart, product]
  );

  return (
    <div className={styles.addRow}>
      <Button
        type="button"
        className={styles.addToCartButton}
        title={`Choose options and add ${
          product?.name || "this product"
        } to the order.`}
        onClick={() => setIsModalOpen(true)}
      >
        Add To Cart
      </Button>
      <AddToCartModal
        product={product}
        isOpen={isModalOpen}
        permissionMessage={permissionMessage}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
}

CartItemActions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  product: PropTypes.object.isRequired,
  onAddToCart: PropTypes.func,
  iboPinCode: PropTypes.string,
  iboMembershipCode: PropTypes.string,
};

CartItemActions.defaultProps = {
  onAddToCart: () => {},
  iboPinCode: "IBO",
  iboMembershipCode: "C",
};

export default CartItemActions;
